module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content-header",
    staticStyle: {
      "height": "50px"
    }
  }, [_c('h1', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.$root.title))]), _vm._v(" "), _c('div', {
    staticClass: "sidebar-form searchBox",
    staticStyle: {
      "width": "200px",
      "float": "right",
      "margin": "0px",
      "border": "1px solid #337ab7"
    },
    attrs: {
      "action": "#",
      "method": "get"
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$root.txtSearch),
      expression: "$root.txtSearch"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "27px",
      "background-color": "#fff"
    },
    attrs: {
      "type": "text",
      "name": "q",
      "placeholder": "Search..."
    },
    domProps: {
      "value": (_vm.$root.txtSearch)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$root, "txtSearch", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "box-tools",
    staticStyle: {
      "float": "right",
      "padding": "0px 10px"
    }
  }, [_c('ul', {
    staticClass: "pagination pagination-sm inline",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('li', {
    class: [_vm.options.activeFilter === 'Online' ? 'active' : '']
  }, [_c('a', {
    staticStyle: {
      "width": "80px!important",
      "text-align": "center"
    },
    on: {
      "click": function($event) {
        _vm.options.activeFilter = 'Online'
      }
    }
  }, [_vm._v("Online")])]), _vm._v(" "), _c('li', {
    class: [_vm.options.activeFilter === 'Offline' ? 'active' : '']
  }, [_c('a', {
    staticStyle: {
      "width": "80px!important",
      "text-align": "center"
    },
    on: {
      "click": function($event) {
        _vm.options.activeFilter = 'Offline'
      }
    }
  }, [_vm._v("Offline")])]), _vm._v(" "), _c('li', {
    class: [_vm.options.activeFilter === 'Out of Paper' ? 'active' : '']
  }, [_c('a', {
    staticStyle: {
      "width": "80px!important",
      "text-align": "center"
    },
    on: {
      "click": function($event) {
        _vm.options.activeFilter = 'Out of Paper'
      }
    }
  }, [_vm._v("Out of Paper")])]), _vm._v(" "), _c('li', {
    class: [_vm.options.activeFilter === 'Low Toner' ? 'active' : '']
  }, [_c('a', {
    staticStyle: {
      "width": "80px!important",
      "text-align": "center"
    },
    on: {
      "click": function($event) {
        _vm.options.activeFilter = 'Low Toner'
      }
    }
  }, [_vm._v("Low Toner")])]), _vm._v(" "), _c('li', {
    class: [_vm.options.activeFilter === 'Errors' ? 'active' : '']
  }, [_c('a', {
    staticStyle: {
      "width": "80px!important",
      "text-align": "center"
    },
    on: {
      "click": function($event) {
        _vm.options.activeFilter = 'Errors'
      }
    }
  }, [_vm._v("Errors")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "table-responsive0"
  }, [_c('div', {
    staticClass: "col-sm-12",
    staticStyle: {
      "padding-left": "0px",
      "background-color": "#ddd",
      "padding-bottom": "10px",
      "border-radius": "5px"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$root.isAdmin),
      expression: "$root.isAdmin"
    }],
    staticClass: "col-sm-2"
  }, [_c('span', [_vm._v("Select Dealer:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.dealerKey),
      expression: "filters.dealerKey"
    }],
    staticClass: "form-control",
    staticStyle: {
      "padding-left": "0px"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filters, "dealerKey", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.sortedDelaers), function(item, index) {
    return _c('option', {
      domProps: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.title))])
  }), 0)]), _vm._v(" "), (_vm.$root.isAdmin || _vm.$root.isDealer) ? _c('div', {
    staticClass: "col-sm-2"
  }, [_c('span', [_vm._v("Select Customer:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.customerKey),
      expression: "filters.customerKey"
    }],
    staticClass: "form-control",
    staticStyle: {
      "padding-left": "0px"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filters, "customerKey", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "All"
    }
  }, [_vm._v("All")]), _vm._v(" "), _vm._l((_vm.customers), function(item, index) {
    return _c('option', {
      domProps: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.title))])
  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('span', [_vm._v("Select Site:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.siteKey),
      expression: "filters.siteKey"
    }],
    staticClass: "form-control",
    staticStyle: {
      "padding-left": "0px"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filters, "siteKey", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "All"
    }
  }, [_vm._v("All")]), _vm._v(" "), _vm._l((_vm.sites), function(item, index) {
    return _c('option', {
      domProps: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.title))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2",
    staticStyle: {
      "height": "54px"
    }
  }, [_c('input', {
    staticClass: "btn btn-success",
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "type": "button",
      "value": "Refresh"
    },
    on: {
      "click": _vm.loadPrintersHistory
    }
  })])]), _vm._v(" "), _c('VueTable', {
    attrs: {
      "isLoading": _vm.isLoading,
      "columns": _vm.columns,
      "rows": _vm.filteredItems,
      "info": _vm.infoIcons,
      "options": _vm.options
    },
    on: {
      "rowClick": _vm.rowClick
    }
  })], 1)]), _vm._v(" "), _c('PrinterInfo')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-btn"
  }, [_c('div', {
    staticClass: "btn btn-flat",
    staticStyle: {
      "height": "28px",
      "padding": "4px 6px",
      "background-color": "#fff"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0dbc04d8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PrintersStatus.vue
// module id = 671
// module chunks = 0